import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import AuthProvider from './services/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Importa todas as páginas e o novo componente de seção
import Homepage from './pages/Homepage';
import CommandsPage from './pages/CommandsPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DashboardPage from './pages/DashboardPage';
import PricingSection from './components/sections/PricingSection'; // 1. Importar o componente correto
import DownloadsPage from './pages/DownloadsPage';
import PluginConnected from './pages/PluginConnected';
import NotFoundPage from './pages/NotFoundPage';

// O painel admin entra por React.lazy: todo o codigo de /admin vira um chunk
// separado, carregado so quando alguem acessa /admin. Mantem o bundle publico
// enxuto e a estrutura do painel fora do JS que o visitante comum baixa.
const AdminApp = React.lazy(() => import('./pages/admin/AdminApp'));

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rotas Públicas com Layout (Header e Footer) */}
          <Route element={<Layout />}>
            <Route path="/" element={<Homepage />} />
            <Route path="/comandos" element={<CommandsPage />} />
          </Route>

          {/* Rotas de Ação e Autenticação (sem o layout principal) */}
          {/* 2. Usar PricingSection em vez de PlansPage */}
          <Route path="/plans" element={<PricingSection />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          {/* Pagina final do login pelo plugin: o plugin redireciona o navegador
              para ca depois de capturar o token no listener local. */}
          <Route path="/plugin-conectado" element={<PluginConnected />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Rotas Privadas: dentro do Layout para herdar o Header e o Footer do
              site — o painel do cliente fica com a mesma cara das paginas
              publicas, em vez de um cabecalho proprio. */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/dashboard/downloads" element={<DownloadsPage />} />
            </Route>
          </Route>

          {/* Painel admin (chunk lazy). O /* deixa o roteamento interno para o
              AdminApp. A protecao real e a RLS no banco; o AdminRoute apenas evita
              renderizar a tela para quem nao e admin. */}
          <Route
            path="/admin/*"
            element={
              <Suspense
                fallback={
                  <div className="flex items-center justify-center min-h-screen text-gray-500">
                    Carregando…
                  </div>
                }
              >
                <AdminApp />
              </Suspense>
            }
          />

          {/* Rota para páginas não encontradas */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
